module.exports = __webpack_public_path__ + "img/ic_teacher_jiaoxue.b738274e.jpg";